"use client"

import dynamic from "next/dynamic"

// Lazy-loaded Mux player, shared by every marketing video surface (perf,
// 2026-07-23): the static `import MuxPlayer from "@mux/mux-player-react"` put
// ~1MB of player code in the first-load bundle of /apply, /testimonials, and
// /book/confirmed even when no video renders (the /testimonials entries have
// no playbackId yet). Loading it as a client-only chunk on first render keeps
// the money pages' critical JS lean; the player mounts one tick later, which
// is invisible next to the poster/thumbnail Mux shows while the stream opens.
// Use this instead of importing @mux/mux-player-react directly.
const LazyMuxPlayer = dynamic(() => import("@mux/mux-player-react"), {
  ssr: false,
  loading: () => <div className="h-full w-full bg-black" aria-hidden />,
})

export default LazyMuxPlayer
